<script lang="ts">
	import {
		AdvancedCard,
		ControlsContainer,
		Label,
		LabelList,
		Text,
	} from '@Shelly/shelly-design-system';
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	$: ppmStatus = statuses.find((i) => /^(ppm)$/.test(i.role));
	$: muteStatus = statuses.find((i) => /^(mute_alarm)$/.test(i.role));
	$: backlightStatus = statuses.find((i) => /^(backlight_enable)$/.test(i.role));
</script>

<div class="lable-list-wrapper-in-drawer-tab-content">
	<LabelList
		class="mb-m justify-content-center"
		size="m"
		data-prevent-drawer-swipe
		data-prevent-sidepanel-swipe
		labelList={statuses.filter((i) =>
			/^(battery_percentage|current_temperature|current_humidity)$/.test(i.role),
		)}
		on:label-click={(e) => {
			e.stopPropagation();
		}}
	/>
</div>
{#if ppmStatus}
	<AdvancedCard title={translateTemplateTitle(ppmStatus.vcName)}>
		<LabelList
			size="m"
			labelList={ppmStatus.labelList || []}
			slot="main"
			data-prevent-drawer-swipe
			data-prevent-sidepanel-swipe
		/>
		<div slot="right">
			<Label
				style="max-width: 100%;"
				size="l"
				value={translateTemplateTitle(ppmStatus.label || ppmStatus.value)}
				icon={ppmStatus.icon}
				iconColor={ppmStatus.iconColor}
			/>
		</div>
	</AdvancedCard>
{/if}

<div class="flex-full-height justify-content-end">
	{#if muteStatus}
		<ControlsContainer class="mt-s">
			<svelte:fragment slot="first">
				<VirtualBooleanButton
					isWide
					{device}
					componentID={muteStatus.id}
					value={muteStatus.event}
					icon={muteStatus.icon}
				/>
				<Text styleType="controls-large" class="mt-s text-bold">
					{translateTemplateTitle(muteStatus.event ? 'Unmute' : 'Mute')}</Text
				>
			</svelte:fragment>
		</ControlsContainer>
	{/if}
	{#if backlightStatus}
		<ControlsContainer class="mt-s">
			<svelte:fragment slot="first">
				<VirtualBooleanButton
					isWide
					{device}
					componentID={backlightStatus.id}
					value={backlightStatus.event}
					icon={backlightStatus.icon}
				/>
				<Text styleType="controls-large" class="mt-s text-bold">
					{translateTemplateTitle(`backlight_${backlightStatus.event ? 'off' : 'on'}`)}</Text
				>
			</svelte:fragment>
		</ControlsContainer>
	{/if}
</div>
